import classNames from 'classnames';
import CustomCheckboxV2 from '../../custom-components/custom-checkbox/CustomCheckboxV2';
import RadioButtonV2 from '../RadioButtonV2';
import SwitchButton from '../switchButton/SwitchButton';
import IconWrapper from '../wrapper/IconWrapper';
import classes from './TextIconNavTile.module.scss';
import AppAvatar from '../app-avatar/AppAvatar';
import { APP_COMPONENT_SIZE } from '../../../utils/constants';

function TextIconOptionTile({
    onClick,
    icon,
    title,
    subtitle,
    statusIcon,
    isCheckbox,
    id,
    name,
    checked,
    onChange,
    value,
    isSwitch,
    grayTitle,
    disabled,
    useAvatar,
    avatarProps,
    size,
}) {
    const getIconSize = () => {
        if (!size) return undefined;

        if (size === APP_COMPONENT_SIZE.medium) return 26;
        return undefined;
    };
    const renderInput = () => {
        if (isSwitch) {
            return <SwitchButton id={id} value={value} isChecked={checked} onChange={onChange} />;
        }

        if (isCheckbox) {
            return (
                <CustomCheckboxV2
                    id={id}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                />
            );
        }

        return (
            <RadioButtonV2
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
                value={value}
            />
        );
    };
    return (
        <label
            className={classNames(
                classes.actionTile,
                disabled && classes.actionTileDisabled,
                size && classes[size]
            )}
            onClick={() => {
                if (!disabled && onClick) onClick();
            }}
        >
            <div className={classes.actionTile__icon}>
                {useAvatar ? (
                    <AppAvatar {...avatarProps} />
                ) : (
                    <IconWrapper
                        iconSize={size && size === APP_COMPONENT_SIZE.medium && 14}
                        size={getIconSize()}
                    >
                        {icon}
                    </IconWrapper>
                )}
                {statusIcon && <div className={classes.actionTile__status}>{statusIcon}</div>}
            </div>
            <div className={classes.actionTile__content}>
                <h4
                    className={classNames(
                        classes.actionTile__title,
                        grayTitle && classes.grayTitle
                    )}
                >
                    {title}
                </h4>
                <p className={classes.actionTile__subtitle}>{subtitle}</p>
            </div>
            <div className={classes.actionTile__arrow}>{renderInput()}</div>
        </label>
    );
}
export default TextIconOptionTile;
